<div class="submit-form">
  <h3 class="title-page text-primary">Tìm kiếm</h3>
  <div class="mb-3 row">
    <div class="col-md-2">
      <label class="form-label" for="declarationNumber">Số tờ khai <label style="color: red;">(*) Tờ khai 11
          số</label> </label>
      <input type="text" class="form-control" maxlength="11" placeholder="Số tờ khai" id="declarationNumber" required
        [(ngModel)]="declarationNumber" name="Số tờ khai" />
    </div>
    <div class="col-md-2">
      <br />
      <button style="margin-top: 8px;" (click)="search()" class="btn btn-success">Tìm kiếm</button>
    </div>
  </div>
</div>

<div *ngIf="registrationVerify">
  <div *ngIf="notFound && notReply" class="text-warning">
    {{messageNotReply}}
  </div>
  <app-registration-verify-details [registrationVerifyInput]="registrationVerify">
  </app-registration-verify-details>
</div>
<div *ngIf="!notFound" class="text-warning">
  {{messageNotFound}}
</div>
